var $09af5659fa5d1530$exports = {};
$09af5659fa5d1530$exports = {
    "Clear search": `\u{15E}terge\u{163}i c\u{103}utarea`
};


export {$09af5659fa5d1530$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
